
import passwordIcon from '../Images/password.png'
import mobile from '../Images/mobile.png'
import barCodeBlack from '../Images/barCodeBlack.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";
import './Forgot.css'
export default function Forgot() {
    let navigate = useNavigate();
    const formRef = useRef(null);
    const [isPosting, setIsPosting] = useState(false);
    const [phone, setPhone] = useState("")
    const [code, setCode] = useState("")
    const [password, setPassword] = useState("")
    const [mode, setMode] = useState("phone")
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (jwt && jwt != "") {
            navigate('/main');
        }
    }, []);


    const changeMobile = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setMode("phone")
    }
    const reSend = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsPosting(true);
        await Services.RequestVerifyCode({ Username: phone })
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                toast.dark("ارسال شد")
                setSeconds(defaultSec);
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    const secondsToTime = (secs) => {
        const h = Math.floor(secs / 3600);
        const m = Math.floor((secs % 3600) / 60);
        const s = secs % 60;
        return { h, m, s };
    };
    
   
    //---------
    const defaultSec = 60 * 2;
    const [seconds, setSeconds] = useState(defaultSec);
    const [time, setTime] = useState(secondsToTime(defaultSec));
    const timerRef = useRef(null);
    useEffect(() => {
        timerRef.current = setInterval(() => {
            setSeconds(prev => {
                const next = prev - 1;
                if (next <= 0) {
                    clearInterval(timerRef.current);
                    return 0;
                }
                return next;
            });
        }, 1000);
        return () => clearInterval(timerRef.current); // پاک‌سازی تایمر هنگام unmount
    }, []);

    useEffect(() => {
        setTime(secondsToTime(seconds));
    }, [seconds]);
     

    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        const service = mode == "phone" ? Services.RequestVerifyCode :
            mode == "verify" ? Services.CheckVerifyCode : Services.ChengePassWithVerifyCode;
        await service(mode == "phone" ? { Username: phone } :
            mode == "verify" ? { Username: phone, code } :
                { mobile: phone, code, Password: password })
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                if (mode == "phone") {
                    setMode("verify")
                    setSeconds(defaultSec);
                }
                else if (mode == "verify")
                    setMode("changePas")
                else if (mode == "changePas")
                    navigate('/login');
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    return (
        <>


            <form ref={formRef} className=" needs-validation">
                {mode == "phone" &&
                    <>
                        <div className="input-group mb-3">
                            <div className="input-group-text" >
                                <img
                                    src={mobile}
                                    className=" " />
                            </div>
                            <input
                                asp-for="Username"
                                type="number"
                                name="Username"
                                value={phone}
                                onChange={e => setPhone(e.target.value)}
                                className="form-control"
                                placeholder="شماره موبایل"
                                required
                                dir="rtl"

                                autoComplete="off" />
                            <span
                                asp-validation-for="Username"
                                className="text-danger" />
                        </div>
                    </>}
                {mode == "verify" &&
                    <>
                        <div className="row">
                            <div className="col">
                                <div className="d-flex justify-content-center">
                                    <span id="CaptionTimer"> {time.s} : {time.m}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className='col'>
                                <div className="row mb-4">
                                    <div className="col d-flex justify-content-center">
                                        <span className="text-white">
                                            به شماره‌ تماس {phone} کد امنیتی ارسال شد. لطفا کد امنیتی را وارد کنید.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-text" >
                                <img
                                    src={barCodeBlack}
                                    className=" " />
                            </div>
                            <input
                                asp-for="Username"
                                type="number"
                                name="Username"
                                value={code}
                                onChange={e => setCode(e.target.value)}
                                className="form-control"
                                placeholder="کد"
                                required
                                autoComplete="off" />
                            <span
                                asp-validation-for="Username"
                                className="text-danger" />
                        </div>
                    </>}
                {mode == "changePas" &&
                    <>
                        <div className="row mt-3">
                            <div className='col'>
                                <div className="row mb-4">
                                    <div className="col d-flex justify-content-center">
                                        <span className="text-danger">
                                            کلمه عبور جدید را وارد فرمایید
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-text" >
                                <img
                                    src={passwordIcon}
                                    className=" " />
                            </div>
                            <input
                                asp-for="password"
                                type="password"
                                name="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                className="form-control"
                                placeholder="کلمه عبور جدید"
                                required
                                autoComplete="off" />
                            <span
                                asp-validation-for="password"
                                className="text-danger" />
                        </div>
                    </>
                }

                <div className='row'>
                    <div className='col'>
                        <button
                            className="w-100 btn btn-lg btn1 py-3"
                            onClick={handlePosting}
                            disabled={isPosting}>
                            تائید
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                        </button>
                    </div>
                </div>
            </form>

            <div className="row mt-4">
                <div className="col d-flex justify-content-center">
                    {mode == "verify" &&
                        <>
                            {seconds == 0 &&
                                <Link
                                    className="textColor1 text-decoration-none ms-1"
                                    to=""
                                    onClick={reSend}>ارسال مجدد </Link>
                            }
                        </>
                    }
                    {mode != "phone" &&
                        <Link
                            className="textColor1 text-decoration-none ms-1"
                            to=""
                            onClick={changeMobile}>تغییر موبایل</Link>
                    }
                    <Link
                        className="textColor1 text-decoration-none ms-1"
                        to="/login">بازگشت</Link>
                </div>
            </div>


        </>

    );

}
